import { Pipe, PipeTransform } from '@angular/core';
import {Helper} from "../../utils/helper.module";

@Pipe({
  name: 'assetimage'
})



export class AssetPipe implements PipeTransform {

  transform(image:any): any {

    if(image && image.length<500)
    {image = Helper.asset(image);}
    return  image;

  }

}
